<!-- SIDE PANEL -->
@if (!cdkConfig.layout.sidepanel.hidden && cdkConfig.layout.sidepanel.position === 'left') {
  <!-- PANEL CONTENT -->
}
<!-- / SIDE PANEL -->

<div id="main">

  <!-- NOTIFICACOES -->
  <ng-container>
    <notification></notification>
  </ng-container>

  <!-- TOOLBAR: Above -->
  @if (cdkConfig.layout.toolbar.position === 'above') {
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  }
  <!-- / TOOLBAR: Above -->

  <!-- NAVBAR: Top -->
  <ng-container>
    <ng-container *ngTemplateOutlet="topNavbar"></ng-container>
  </ng-container>
  <!-- / NAVBAR: Top -->

  <!-- TOOLBAR: Below -->
  @if (cdkConfig.layout.toolbar.position === 'below') {
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  }
  <!-- / TOOLBAR: Below -->

  <div id="container-1" class="container">

    <!-- NAVBAR: Left -->
    <ng-container>
      <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
    </ng-container>
    <!-- / NAVBAR: Left -->

    <div id="container-2" class="container">

      <div id="container-3" class="container" cdkScrollbar
        [cdkScrollbarOptions]="{suppressScrollX: false}">

        <!-- CONTENT -->
        <content></content>
        <!-- / CONTENT -->

        <!-- FOOTER: Below -->
        @if (cdkConfig.layout.footer.position === 'above-static') {
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        }
        <!-- / FOOTER: Below -->

      </div>

    </div>

  </div>

  <!-- FOOTER: Above -->
  @if (cdkConfig.layout.footer.position === 'above-fixed') {
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  }
  <!-- FOOTER: Above -->

</div>

<!-- SIDE PANEL -->
@if (!cdkConfig.layout.sidepanel.hidden && cdkConfig.layout.sidepanel.position === 'right') {
  <!-- PANEL CONTENT -->
}
<!-- / SIDE PANEL -->

<!-- AJUDA PANEL -->
<cdk-sidebar name="ajudaPanel" position="right" [ngClass]="{'ajuda-panel': !mobileMode, 'ajuda-panel-mobile': mobileMode}">
  <ajuda-panel tabindex="-1"></ajuda-panel>
</cdk-sidebar>
<!-- / AJUDA PANEL -->

<!-- CHAT PANEL -->
<cdk-sidebar name="chatPanel" position="right" class="chat-panel" tabindex="-1"
  [ngClass]="{'chat-open': chatOpen === true}"
  [folded]="false"
  [foldedAutoTriggerOnHover]="false"
  [class.hidden]="false"
  *showIfRole="'ROLE_COLABORADOR'">
  <chat-panel tabindex="-1" (toogleChatHandler)="toogleChat($event)">
  </chat-panel>
</cdk-sidebar>
<!-- / CHAT PANEL -->

<!-- QUICK PANEL -->
<cdk-sidebar name="quickPanel" position="right" class="quick-panel"
  [folded]="true"
  lockedOpen="gt-md"
  [foldedWidth]="56"
  [foldedAutoTriggerOnHover]="false"
  [class.hidden]="false">
  <quick-panel></quick-panel>
</cdk-sidebar>
<!-- / QUICK PANEL -->

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS                                                                                            -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
  @if (!cdkConfig.layout.toolbar.hidden) {
    <toolbar
      [ngClass]="cdkConfig.layout.toolbar.customBackgroundColor === true ? cdkConfig.layout.toolbar.position + ' ' + cdkConfig.layout.toolbar.background : cdkConfig.layout.toolbar.position">
    </toolbar>
  }
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
  @if (!cdkConfig.layout.footer.hidden) {
    <footer
      [ngClass]="cdkConfig.layout.footer.customBackgroundColor === true ? cdkConfig.layout.footer.position + ' ' + cdkConfig.layout.footer.background : cdkConfig.layout.footer.position">
    </footer>
  }
</ng-template>
<!-- / FOOTER -->

<!-- TOP NAVBAR -->
<ng-template #topNavbar>
  @if (!cdkConfig.layout.navbar.hidden) {
    <navbar variant="horizontal-style-1"
      class="top-navbar xs:max-lg:hidden"
      >
    </navbar>
  }
</ng-template>
<!-- / TOP NAVBAR -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
  @if (!cdkConfig.layout.navbar.hidden) {
    <cdk-sidebar name="navbar" class="navbar-cdk-sidebar"
      [folded]="cdkConfig.layout.navbar.folded"
      >
      <navbar [variant]="cdkConfig.layout.navbar.variant" class="left-navbar"></navbar>
    </cdk-sidebar>
  }
</ng-template>
<!-- / LEFT NAVBAR -->
